import { ElementDetails } from "@/lib/types";
import { FieldSize } from "../ElementSettings/FieldSize";

export const details = {
  name: "Bookmarks",
  description: "Display a list of bookmarks",
  category: "Widget",
  grid: {},
  defaultProps: {
    links: [],
    wrapped: true,
    display: "column",
    showIcons: false,
    displayTitle: true,
    title: "Bookmarks",
    gap: "",
  },
  fields: [
    {
      prop: "wrapped",
      title: "Wrapped",
      type: "checkbox",
      config: {},
    },
    {
      prop: "displayTitle",
      title: "Display Title",
      type: "checkbox",
      config: {},
    },
    {
      prop: "title",
      title: "Title",
      type: "input",
      config: {},
    },
    {
      prop: "showIcons",
      title: "Show Icons",
      type: "checkbox",
      config: {},
    },
    {
      prop: "display",
      title: "Display Mode",
      type: "radio",
      config: {
        options: [
          { title: "Column", value: "column" },
          { title: "Row", value: "row" },
        ],
      },
    },
    {
      prop: "gap",
      title: "Gap",
      type: "custom",
      config: {
        render: props => (
          <FieldSize allowAuto={false} units={["px", "rem"]} {...props} />
        ),
      },
    },
    {
      prop: "links",
      title: "Links",
      type: "array",
      config: {},
      children: [
        { prop: "title", title: "Title", type: "input", config: {} },
        { prop: "url", title: "URL", type: "input", config: {} },
        { prop: "customIcon", title: "Custom Icon", type: "input", config: {} },
      ],
    },
  ],
} as ElementDetails;
